export interface UBTItem {
  id?: string;
  teamId?: string;
  ubtName?: string;
  teamName?: string;
  nuid?: string;
  teamRating?: string;
  glString?: string;
  glstring?: string;
  company?: string;
  entity?: string;
  kpAreaDesc?: string;
  area?: string;
  glLocNm?: string;
  location?: string;
  costCenter?: string;
  shift?: string;
  /** Region code from cost center (kpGlRegionCd). */
  kpGlRegionCd?: string;
  /** Area code from cost center (kpAreaCd). */
  kpAreaCd?: string;
  /** Service area / center code from cost center (kpSvcArea). */
  kpSvcArea?: string;
  /** Location code from cost center (glLocCd). */
  glLocCd?: string;
}

export interface GroupedUBT {
  id: string;
  ubtName: string;
  nuid: string | null;
  details: Array<{
    teamRating?: string;
    glstring?: string;
    entity?: string;
    area?: string;
    location?: string;
    costCenter?: string;
    shift?: string;
    nuid?: string;
    kpGlRegionCd?: string;
    kpAreaCd?: string;
    kpSvcArea?: string;
    glLocCd?: string;
  }>;
}

export const groupUBTItemsByTeam = (items: UBTItem[]): GroupedUBT[] => {
  return items.reduce((acc: GroupedUBT[], item: UBTItem) => {
    const teamId = String(item.id ?? item.teamId ?? "");
    const teamName = String(item.ubtName ?? item.teamName ?? "");
    const nuid = item.nuid ?? null;

    const existingTeam = acc.find(
      (t) => t.id === teamId && t.ubtName === teamName,
    );

    const detail = {
      teamRating: item.teamRating,
      glstring: item.glString ?? item.glstring,
      entity: item.company ?? item.entity,
      area: item.kpAreaDesc ?? item.area,
      location: item.glLocNm ?? item.location,
      costCenter: item.costCenter,
      shift: item.shift,
      nuid: item.nuid,
      kpGlRegionCd: item.kpGlRegionCd,
      kpAreaCd: item.kpAreaCd,
      kpSvcArea: item.kpSvcArea,
      glLocCd: item.glLocCd,
    };

    if (existingTeam) {
      existingTeam.details.push(detail);
    } else {
      acc.push({
        id: teamId,
        ubtName: teamName,
        nuid,
        details: [detail],
      });
    }

    return acc;
  }, []);
};
